import { toUrl } from "../utils.js";
export const OBJECT_TO_DIRECTIVES_MAP = {
  width: "w",
  height: "h",
  autoWidthWithFallback: "w_auto",
  auto_width_fallback: "w_auto",
  scaleToScreenWidth: "pc",
  scale_to_screen_width: "pc",
  crop: "cr",
  outputFormat: "f",
  format: "f",
  fit: "m",
  fitMethod: "m",
  compression: "cmpr",
  sharpness: "s",
  rotate: "r",
  inline: "in",
  keepMeta: "meta",
  keep_meta: "meta",
  noOptimization: "pass",
  no_optimization: "pass",
  force_download: "dl",
  max_device_pixel_ratio: "maxdpr",
  maxDevicePixelRatio: "maxdpr"
};
export const parse = imageUrl => {
  const parsedUrl = toUrl(imageUrl);
  const paramArray = getParameterArray(parsedUrl);
  const baseUrl = getBaseUrl(parsedUrl);
  let width = undefined,
    height = undefined,
    format = undefined;
  const params = {};
  if (paramArray.length > 0) {
    paramArray.forEach(para => {
      let key_value = para.split("_");
      if (key_value.length > 1) {
        switch (key_value[0]) {
          case "w":
            width = Number(key_value[1]);
            break;
          case "h":
            height = Number(key_value[1]);
            break;
          case "f":
            format = key_value[1];
            break;
          default:
            if (Object.values(OBJECT_TO_DIRECTIVES_MAP).includes(key_value[0])) {
              let directive = getDirective(key_value[0]);
              params[directive] = key_value[1];
            }
        }
      }
    });
  }
  return {
    base: baseUrl,
    width,
    height,
    format,
    params,
    cdn: "imageengine"
  };
};
export function getDirective(key) {
  let keyArray = Object.keys(OBJECT_TO_DIRECTIVES_MAP);
  let directive = keyArray.find(k => OBJECT_TO_DIRECTIVES_MAP[k] === key) || "";
  return directive;
}
export function getParameterArray(url) {
  let url_string = url.toString();
  let paramArray = [];
  if (url_string) {
    let splitURL = url_string.split("imgeng=");
    if (splitURL.length > 1) {
      paramArray = splitURL[1].split("/");
    }
  }
  return paramArray;
}
export function getBaseUrl(url) {
  let url_string = url.toString();
  let baseUrl = "";
  if (url_string) {
    let splitURL = url_string.split("imgeng=");
    if (splitURL.length > 1) {
      baseUrl = splitURL[0].slice(0, -1);
    } else {
      baseUrl = url_string;
    }
  }
  return baseUrl;
}
export const transform = _ref => {
  let {
    url: originalUrl,
    width,
    height,
    format
  } = _ref;
  const url = toUrl(originalUrl);
  const src = getBaseUrl(url);
  let directives = {};
  const param = url.toString() === src ? [] : getParameterArray(url);
  if (param.length) {
    directives = getDirectives(param);
  }
  if (width) {
    directives["width"] = width;
  }
  if (height) {
    directives["height"] = height;
  }
  if (format) {
    directives["format"] = format;
  }
  if (!directives.hasOwnProperty("fit")) {
    directives = Object.assign({}, directives, {
      "fit": "cropbox"
    });
  }
  let directives_string = build_IE_directives(directives);
  let query_string = build_IE_query_string(directives_string);
  let query_prefix = query_string === "" ? "" : src.includes("?") ? "&" : "?";
  return "" + src + query_prefix + query_string;
};
export function build_IE_directives(directives) {
  return Object.entries(directives).reduce((acc, _ref2) => {
    let [k, v] = _ref2;
    return acc + maybe_create_directive(k, v);
  }, "");
}
export function build_IE_query_string(directives_string) {
  if (directives_string && directives_string !== "") {
    return "imgeng=" + directives_string;
  }
  return "";
}
export function maybe_create_directive(directive, value) {
  let translated_directive = OBJECT_TO_DIRECTIVES_MAP[directive];
  if (translated_directive && (value || value === 0)) {
    return "/" + translated_directive + "_" + value;
  }
  return "";
}
export function getDirectives(paramArray) {
  let directives = {};
  paramArray.forEach(para => {
    let keyValue = para.split("_");
    if (keyValue.length > 1) {
      let key = keyValue[0];
      let value = keyValue[1];
      let directiveKey = getDirective(key);
      if (directiveKey) {
        directives[directiveKey] = value;
      }
    }
  });
  return directives;
}